import { BaseEntity } from 'src/app/tools/models/baseEntity'
import { PriceListLine } from './price-list-line-entity';

export class PriceList extends BaseEntity {
    priceListCode   : string;
    name            : string;
    rank            : number;

    priceListLines  : PriceListLine[] = [];
}